import { BaseReducer } from '@identic/api';
import { SpeciesState, SpeciesInitialState, SpeciesActions } from './species.state';

export function SpeciesReducer(state: SpeciesState = SpeciesInitialState, action: any): SpeciesState {
  return BaseReducer(state, action, SpeciesActions);
}
// console.log(`%cSpeciesReducer::ngOnInit`, 'background:yellow');
